/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author: DQTuan
 * @crated at: 26/12/2024
 *
 **/

export enum MeetingType {
	CONFERENCE = "conference",
	SCHEDULE = "schedule"
}

export enum MeetingStatus {
	OPEN = "OPEN",
	CLOSED = "CLOSED"
}

